// extracted by mini-css-extract-plugin
export default {"content":"aZnv8_XE"};